import mapFunction from './mapResources';

export default mapFunction('operation_work', {
    isFetching: false,
    items: [] 
});
